// DS: IL10.2
import React from 'react';

export interface Props {
  className?: string;
}

export const Alert: React.FC<Props> = ({ className }) => {
  return (
    <img
      alt=""
      src="https://st.deviantart.net/eclipse/global/svg/il10-2.svg"
      width="140"
      height="140"
      className={className}
    />
  );
};
